export default __webpack_public_path__ + "static/careers-bma-awards-f51f6a947647d20d5fe326ba4dc8b8ad.png";